import { createBrowserRouter } from "react-router-dom"

import { AuthRouter } from "@src/router/Auth.router"
import { AppRouter } from "@src/router/App.router"
import { PWARouter } from "@src/router/PWA.router"
import { ErrorRouter } from "@src/router/Error.router"

// ErrorRouter placed last so catch-all 404 doesn't override other routes
const Router = createBrowserRouter([...AuthRouter, ...AppRouter, ...PWARouter, ...ErrorRouter])

export default Router
